import { render, staticRenderFns } from "./AdditionalInfoComponent.vue?vue&type=template&id=5d60ba1a&scoped=true&"
import script from "./AdditionalInfoComponent.vue?vue&type=script&lang=js&"
export * from "./AdditionalInfoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d60ba1a",
  null
  
)

export default component.exports